var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeOff3 = function SvgVolumeOff3(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume-off-3",
    clipPath: "url(#clip0_1388_137879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "volume-off--speaker-music-mute-volume-control-audio-off-mute-entertainment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9577 12.9582L1.04102 1.0415",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.30817 11.5669C9.10999 11.5781 8.91378 11.5226 8.75083 11.4092L5.16667 8.83341H3.79167C3.29208 8.83341 2.875 8.41632 2.875 7.91674V6.08341C2.875 5.84874 2.96667 5.6324 3.117 5.46924",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.16602 5.16659L8.83268 2.59076C8.96555 2.49792 9.1216 2.44384 9.28342 2.43454C9.44524 2.42525 9.60646 2.46111 9.74908 2.53813C9.8917 2.61514 10.0101 2.73028 10.0911 2.87069C10.1721 3.01109 10.2124 3.17124 10.2077 3.33326V10.2009",
    stroke: "#808080",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_137879"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeOff3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "volume-off-3.648a965fb2d45502f9c20a1052a2870b.svg";